export default "__VITE_ASSET__d4e5a7b9__"